import type { SVGProps } from 'react';
const SvgIconDeadletter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M5.97 9.22a.75.75 0 0 1 1.06 0l.97.97.97-.97.056-.052a.75.75 0 0 1 1.004.052l1.5 1.5a.75.75 0 1 1-1.06 1.06l-.97-.97-.97.97a.75.75 0 0 1-1.004.052l-.056-.052-.97-.97-.97.97-.056.052a.75.75 0 0 1-1.056-1.056l.052-.056zm.306-5.052a.75.75 0 0 1 1.056 1.056l-.052.056-.72.72.72.72.052.056a.75.75 0 0 1-1.056 1.056L6.22 7.78l-.72-.72-.72.72-.056.052a.75.75 0 0 1-1.056-1.056l.052-.056.72-.72-.72-.72-.052-.056a.75.75 0 0 1 1.056-1.056l.056.052.72.72.72-.72zm5 0a.75.75 0 0 1 1.056 1.056l-.052.056-.72.72.72.72.052.056a.75.75 0 0 1-1.056 1.056l-.056-.052-.72-.72-.72.72-.056.052a.75.75 0 0 1-1.056-1.056l.052-.056.72-.72-.72-.72-.052-.056a.75.75 0 0 1 1.056-1.056l.056.052.72.72.72-.72z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5 1A3.5 3.5 0 0 1 15 4.5v7a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 1 11.5v-7A3.5 3.5 0 0 1 4.5 1zM4.296 2.51A2 2 0 0 0 2.5 4.5v7l.01.204a2 2 0 0 0 1.786 1.785l.204.011h7l.204-.01a2 2 0 0 0 1.785-1.786l.011-.204v-7a2 2 0 0 0-1.796-1.99L11.5 2.5h-7z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDeadletter;
